import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBag } from 'lucide-react';
import { Button } from './ui/Button';
const products = [{
  id: 1,
  name: 'Phantom Aegis Controller',
  edition: 'First Edition / 500',
  price: 189,
  image: 'https://images.unsplash.com/photo-1592840496011-a884ad741a9e?w=800&q=80'
}, {
  id: 2,
  name: 'Solstice Guardian Figure',
  edition: 'Artist Proof',
  price: 275,
  image: 'https://images.unsplash.com/photo-1608278047522-446e911d0494?w=800&q=80'
}, {
  id: 3,
  name: 'Obsidian Vault Steelbook',
  edition: 'Standard Issue',
  price: 129,
  image: 'https://images.unsplash.com/photo-1616588589676-60b30c3c1681?w=800&q=80'
}, {
  id: 4,
  name: 'Void Walker Headset',
  edition: 'Limited Run',
  price: 215,
  image: 'https://images.unsplash.com/photo-1546435770-a3e426bf472b?w=800&q=80'
}];
export function ProductGrid() {
  return <section className="py-24 bg-[#0A0A0A]" data-id="element-191">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-192">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-193">
          <div data-id="element-194">
            <span className="text-[#C9A962] font-mono text-sm tracking-widest uppercase block mb-2" data-id="element-195">
              New Arrivals
            </span>
            <h2 className="text-4xl font-serif text-[#F5F5F0]" data-id="element-196">
              Latest Acquisitions
            </h2>
          </div>
          <Button variant="outline" className="mt-6 md:mt-0" data-id="element-197">
            View All Products
          </Button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-198">
          {products.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group" data-id="element-199">
              <div className="relative aspect-[4/5] overflow-hidden bg-[#111] mb-4 border border-[#F5F5F0]/5 group-hover:border-[#C9A962]/30 transition-colors duration-300" data-id="element-200">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 opacity-80 group-hover:opacity-100" data-id="element-201" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center p-6" data-id="element-202">
                  <Button size="sm" className="w-full translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-203">
                    Add to Cart
                  </Button>
                </div>
                <div className="absolute top-3 right-3 bg-[#0A0A0A]/80 backdrop-blur px-2 py-1" data-id="element-204">
                  <span className="text-[#C9A962] font-mono text-xs" data-id="element-205">
                    €{product.price}
                  </span>
                </div>
              </div>

              <h3 className="text-lg font-medium text-[#F5F5F0] group-hover:text-[#C9A962] transition-colors" data-id="element-206">
                {product.name}
              </h3>
              <p className="text-[#F5F5F0]/50 text-sm font-mono mt-1" data-id="element-207">
                {product.edition}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}